import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Badge, BadgeProps, PageHeader, PageHeaderProps } from 'antd';

interface BadgePropsWithColor extends BadgeProps {
  statuscolor: string;
}

export const BadgeStyled: FunctionComponent<BadgePropsWithColor> = styled(Badge)`
  .ant-badge-count {
    border-radius: 0.18rem;
    background-color: ${(props: BadgePropsWithColor) => props.statuscolor};
    padding: 0.18rem 0.5rem 0.063rem;
    font-family: Nunito;
    font-size: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.5rem;
    margin-left: 0.5rem;
    text-transform: uppercase;
  }
`;

export const PageHeaderStyled: FunctionComponent<PageHeaderProps> = styled(PageHeader)`
  padding: 0;
  .ant-page-header-heading-title {
    display: flex;
    align-items: center;
  }
`;
